module.exports = __webpack_public_path__ + "static/img/27-3.ffe5de0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/27-3.jpg
// module id = 7K95
// module chunks = 0